module.exports = __webpack_public_path__ + "static/media/icon_powder.1b6c8ab8.svg";